import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import RadioButtonGroup from "../../common/RadioButtonGroup";
import RadioButtonText from "../../common/RadioButtonText";
import SelectInput from "../../common/SelectInput";
import TextInput from "../../common/TextInput";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import CheckBoxWithChild from "../../common/CheckBoxWithChild";
import TextAreaInput from "../../common/TextAreaInput";
import ValidationGroup from "../../common/ValidationGroup";

import * as domainConstants from "../../../constants/DomainConstants";

const StedenbouwkundigHaalbaar = props => {

	const STEDENBOUWKUNDIGE_BESTEMMING = "De stedenbouwkundige bestemming bepaalt welke activiteiten er mogen plaatsvinden in de betrokken zone, waar al dan niet mag worden gebouwd en aan welke stedenbouwkundige voorschriften gebouwen en constructies moeten voldoen. Er kan ook opgelegd worden hoe een bepaald gebied ingericht en beheerd moet worden. De stedenbouwkundige bestemming bepaalt of je sportinfrastructuur kan bouwen op een bepaald terrein. ";
	const BPA = "Een BPA of een bijzonder plan van aanleg is een bestemmingsplan waarmee de overheid in een bepaald gebied de stedenbouwkundige bestemming vastlegt in afwijking van het gewestplan. Een BPA bevat stedenbouwkundige voorschriften. Door de gewijzigde wetgeving kunnen geen BPA's meer worden opgemaakt. De bestaande BPA's blijven echter van kracht zolang er geen RUP is opgemaakt dat het BPA vervangt.";
	const RUP = "Een ruimtelijk uitvoeringsplan of RUP is een bestemmingsplan waarmee de overheid in een bepaald gebied de stedenbouwkundige bestemming vastlegt. Een RUP vervangt altijd het bestaande gewestplan. Een goedgekeurd RUP bevat stedenbouwkundige voorschriften. ";
	const MER = "Voor sommige activiteiten of projecten is de opmaak van een project-MER (milieueffectenrapport) vereist. Dit is een onderzoek naar de mogelijke gevolgen van het project voor mens en leefmilieu. Voor kleinere projecten volstaat een project-MER-screening. ";
	const INPLANTING_TOEGESTAAN = "Stedenbouwkundige voorschriften leggen heel concreet de spelregels vast. Ze zeggen iets over de bestemming én inrichting van jouw perceel. Ze bepalen wat er op jouw perceel wel of niet kan (bijvoorbeeld toegelaten bouwhoogte, maximum bouwvolume, daktype, dakhelling, type verhardingen, …). Stedenbouwkundige voorschriften zijn opgenomen in bestemmingsplannen en/ of verordeningen en vormen de basis voor het afleveren van vergunningen.";
	const EIGENLIJKE_BESTEMMING = "Bij de eigenlijke bestemming vul je de exacte naam in van de stedenbouwkundige bestemming van het gebied, op basis van het op deze locatie geldende gewestplan/BPA/RUP. Bijvoorbeeld zone voor dag- en verblijfsrecreatie, zone voor dagrecreatie met een open karakter, ontginningsgebied met nabestemming dagrecreatie, stedelijk ontwikkelingsgebied, woongebied, …";
	const {
		minimaleEisen,
		disabled,
		errors,
		onChange,
		color,
		fileTypes,
		mapDeleteFile,
		mapDropFiles,
		getFilesForDossierComponent,
		hasFilesForDossierComponent,
		dossierType,
		stedenbouwkundigeBestemmingen,
		fileSessionStarted,
		standVanZakenMER,
		validationMessageType
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	return (
		<Fieldset title="Is het project stedenbouwkundig haalbaar?">
			<FieldsetSubHeader>Wat is de stedenbouwkundige bestemming van het perceel waarop de sportinfrastructuur zich bevindt?</FieldsetSubHeader>
			<SelectInput
				label=""
				tooltip={STEDENBOUWKUNDIGE_BESTEMMING}
				name="stedenbouwkundigeBestemming"
				value={minimaleEisen.stedenbouwkundigeBestemming}
				items={stedenbouwkundigeBestemmingen}
				disabled={disabled}
				onChange={onChange}
				validationMessage={errors ? errors.stedenbouwkundigeBestemming : ''}
				validationMessageType={validationMessageType}
				size={minimaleEisen.stedenbouwkundigeBestemming == 121450011 || minimaleEisen.stedenbouwkundigeBestemming === "121450011" ? 6 : 12}
			/>
			{minimaleEisen.stedenbouwkundigeBestemming == 121450011 || minimaleEisen.stedenbouwkundigeBestemming === "121450011" ?
				<TextInput
					label="Toelichting andere stedenbouwkundige bestemming"
					name="toelichtingAndereStedenbouwkundigeBestemming"
					onChange={onChange}
					value={minimaleEisen.toelichtingAndereStedenbouwkundigeBestemming}
					size={6}
					disabled={disabled}
					validationMessage={errors ? errors.toelichtingAndereStedenbouwkundigeBestemming : ''}
					maxLength={2000}
					validationMessageType={validationMessageType} />
				: null}

			<FieldsetSubHeader>Toon deze stedenbouwkundige bestemming op basis van?</FieldsetSubHeader>
			<div className="o-col-12">
				<ValidationGroup errors={errors ? errors.hasCoordinatenLigging : undefined} >
					<CheckBoxWithChild
						name="gewestplan"
						label="Gewestplan"
						value={minimaleEisen.gewestplan}
						onChange={onChange}
						size={12}
						validationMessage={errors ? errors.gewestplan : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
						locked={hasFilesForDossierComponent(domainConstants.ComponentName.Gewestplan)}
					/>
					{minimaleEisen.gewestplan === true ?
						<DownloadUploadFiles
							dossierId={minimaleEisen.dossierId}
							infrastructuurId={minimaleEisen.infrastructuur.id}
							title="Uitsnit gewestplan"
							disabled={disabled}
							color={color}
							tab={domainConstants.DocumentTab.MinimaleEisen}
							component={domainConstants.ComponentName.Gewestplan}
							onDelete={mapDeleteFile(domainConstants.ComponentName.Gewestplan)}
							onDrop={mapDropFiles(domainConstants.ComponentName.Gewestplan)}
							files={getFilesForDossierComponent(domainConstants.ComponentName.Gewestplan)}
							fileTypes={fileTypes.Gewestplan}
							validationMessage={errors ? errors.ulGewestplan : ''}
							validationMessageType={validationMessageType}
							fileSessionStarted={fileSessionStarted} />
						:
						null}
					<CheckBoxWithChild
						name="bpa"
						label="BPA"
						value={minimaleEisen.bpa}
						onChange={onChange}
						size={12}
						validationMessage={errors ? errors.bpa : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
						locked={hasFilesForDossierComponent(domainConstants.ComponentName.BPAPlan) || hasFilesForDossierComponent(domainConstants.ComponentName.BPAVoorwaarden)}
					/>
					{minimaleEisen.bpa === true ?
						<div className={"o-col-12"}>
							<DownloadUploadFiles
								dossierId={minimaleEisen.dossierId}
								infrastructuurId={minimaleEisen.infrastructuur.id}
								title="BPA: grafisch plan"
								disabled={disabled}
								color={color}
								tab={domainConstants.DocumentTab.MinimaleEisen}
								component={domainConstants.ComponentName.BPAPlan}
								onDelete={mapDeleteFile(domainConstants.ComponentName.BPAPlan)}
								onDrop={mapDropFiles(domainConstants.ComponentName.BPAPlan)}
								files={getFilesForDossierComponent(domainConstants.ComponentName.BPAPlan)}
								fileTypes={fileTypes.BPAGrafischPlan}
								validationMessage={errors ? errors.ulbpaGrafischPlan : ''}
								validationMessageType={validationMessageType}
								fileSessionStarted={fileSessionStarted}
								size={6} />
							<DownloadUploadFiles
								dossierId={minimaleEisen.dossierId}
								infrastructuurId={minimaleEisen.infrastructuur.id}
								title="BPA: stedenbouwkundige voorwaarden"
								disabled={disabled}
								color={color}
								tab={domainConstants.DocumentTab.MinimaleEisen}
								component={domainConstants.ComponentName.BPAVoorwaarden}
								onDelete={mapDeleteFile(domainConstants.ComponentName.BPAVoorwaarden)}
								onDrop={mapDropFiles(domainConstants.ComponentName.BPAVoorwaarden)}
								files={getFilesForDossierComponent(domainConstants.ComponentName.BPAVoorwaarden)}
								fileTypes={fileTypes.BPAStedenbouwkundigeVoorwaarden}
								validationMessage={errors ? errors.ulbpaStedenbouwkundigeVoorwaarden : ''}
								validationMessageType={validationMessageType}
								fileSessionStarted={fileSessionStarted}
								size={6} />
						</div>
						: null}
					<CheckBoxWithChild
						name="rup"
						label="RUP"
						value={minimaleEisen.rup}
						onChange={onChange}
						size={12}
						validationMessage={errors ? errors.rup : ''}
						validationMessageType={validationMessageType}
						disabled={disabled}
						locked={hasFilesForDossierComponent(domainConstants.ComponentName.RUPPlan) || hasFilesForDossierComponent(domainConstants.ComponentName.RUPVoorwaarden)}
					/>
					{minimaleEisen.rup === true ?
						<div className={"o-col-12"}>
							<DownloadUploadFiles
								dossierId={minimaleEisen.dossierId}
								infrastructuurId={minimaleEisen.infrastructuur.id}
								title="RUP: grafisch plan"
								disabled={disabled}
								color={color}
								tab={domainConstants.DocumentTab.MinimaleEisen}
								component={domainConstants.ComponentName.RUPPlan}
								onDelete={mapDeleteFile(domainConstants.ComponentName.RUPPlan)}
								onDrop={mapDropFiles(domainConstants.ComponentName.RUPPlan)}
								files={getFilesForDossierComponent(domainConstants.ComponentName.RUPPlan)}
								fileTypes={fileTypes.RUPGrafischPlan}
								validationMessage={errors ? errors.ulrupGrafischPlan : ''}
								validationMessageType={validationMessageType}
								fileSessionStarted={fileSessionStarted}
								size={6} />
							<DownloadUploadFiles
								dossierId={minimaleEisen.dossierId}
								infrastructuurId={minimaleEisen.infrastructuur.id}
								title="RUP: stedenbouwkundige voorwaarden"
								disabled={disabled}
								color={color}
								tab={domainConstants.DocumentTab.MinimaleEisen}
								component={domainConstants.ComponentName.RUPVoorwaarden}
								onDelete={mapDeleteFile(domainConstants.ComponentName.RUPVoorwaarden)}
								onDrop={mapDropFiles(domainConstants.ComponentName.RUPVoorwaarden)}
								files={getFilesForDossierComponent(domainConstants.ComponentName.RUPVoorwaarden)}
								fileTypes={fileTypes.RUPStedenbouwkundigeVoorwaarden}
								validationMessage={errors ? errors.ulrupStedenbouwkundigeVoorwaarden : ''}
								validationMessageType={validationMessageType}
								fileSessionStarted={fileSessionStarted}
								size={6} />
						</div>
						:
						null}
				</ValidationGroup>
			</ div>

			<FieldsetSubHeader>Is het project vergunningsplichtig?</FieldsetSubHeader>
			<RadioButtonGroup
				label={"Inzake stedenbouw?"}
				name="werkvergunningPlichtigStedenbouw"
				value={minimaleEisen.werkvergunningPlichtigStedenbouw}
				onChange={onChange}
				disabled={disabled}
				items={jaNee}
				horizontal
				validationMessage={errors ? errors.werkvergunningPlichtigStedenbouw : ''}
				validationMessageType={validationMessageType}
				locked={hasFilesForDossierComponent(domainConstants.ComponentName.Vergunning)}
				labelInside />
			<RadioButtonGroup
				label={"Inzake leefmilieu?"}
				name="werkvergunningPlichtigLeefmilieu"
				value={minimaleEisen.werkvergunningPlichtigLeefmilieu}
				onChange={onChange}
				disabled={disabled}
				items={jaNee}
				horizontal
				validationMessage={errors ? errors.werkvergunningPlichtigLeefmilieu : ''}
				validationMessageType={validationMessageType}
				locked={hasFilesForDossierComponent(domainConstants.ComponentName.Vergunning)}
				labelInside />
			{minimaleEisen.werkvergunningPlichtigLeefmilieu == true || minimaleEisen.werkvergunningPlichtigStedenbouw == true || minimaleEisen.werkvergunningPlichtigLeefmilieu === "true" || minimaleEisen.werkvergunningPlichtigStedenbouw === "true" ?
				<div>
					<RadioButtonGroup
						label={"Is de omgevingsvergunning reeds in jullie bezit?"}
						name="vergunningAlAanwezig"
						value={minimaleEisen.vergunningAlAanwezig}
						onChange={onChange}
						disabled={disabled}
						locked={hasFilesForDossierComponent(domainConstants.ComponentName.Vergunning)}
						items={jaNee}
						horizontal
						validationMessage={errors ? errors.vergunningAlAanwezig : ''}
						validationMessageType={validationMessageType}
						tooltipWindowWidth={45}
						tooltip="De omgevingssvergunning verenigt en vervangt de stedenbouwkundige vergunning en de milieuvergunning. Vanaf 1 januari 2018 zullen alle gemeenten overstappen naar het digitaal loket voor omgevingsvergunningen." />
					{minimaleEisen.vergunningAlAanwezig === "true" || minimaleEisen.vergunningAlAanwezig == true ?
						<DownloadUploadFiles
							dossierId={minimaleEisen.dossierId}
							infrastructuurId={minimaleEisen.infrastructuur.id}
							title="Vergunning"
							center
							disabled={disabled}
							color={color}
							tab={domainConstants.DocumentTab.MinimaleEisen}
							component={domainConstants.ComponentName.Vergunning}
							onDelete={mapDeleteFile(domainConstants.ComponentName.Vergunning)}
							onDrop={mapDropFiles(domainConstants.ComponentName.Vergunning)}
							files={getFilesForDossierComponent(domainConstants.ComponentName.Vergunning)}
							fileTypes={fileTypes.Vergunning}
							validationMessage={errors ? errors.ulVergunning : ''}
							validationMessageType={validationMessageType}
							fileSessionStarted={fileSessionStarted} />
						: ""}

					<RadioButtonText
						label={"Is het project MER-plichtig?"}
						tooltip={MER}
						tooltipWindowWidth={35}
						name={"merVanToepassing"}
						value={minimaleEisen.merVanToepassing}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						validationMessage={errors ? errors.merVanToepassing : ''}
						validationMessageType={validationMessageType}
					/>
					{minimaleEisen.merVanToepassing == "true" || minimaleEisen.merVanToepassing === true ?
						<div>
							<RadioButtonText
								label={"Wat is de stand van zaken van het project-MER?  "}
								name={"merStandVanZaken"}
								value={minimaleEisen.merStandVanZaken}
								onChange={onChange}
								disabled={disabled}
								items={standVanZakenMER}
								horizontal
								validationMessage={errors ? errors.merStandVanZaken : ''}
								validationMessageType={validationMessageType}
							/>
							{minimaleEisen.merStandVanZaken != null && (minimaleEisen.merStandVanZaken != "121450000" && minimaleEisen.merStandVanZaken !== 121450000) ?
								<TextAreaInput
									name={"naamVanMER"}
									label={"Naam van het MER"}
									value={minimaleEisen.naamVanMER}
									onChange={onChange}
									disabled={disabled}
									validationMessage={errors ? errors.naamVanMER : ''}
									validationMessageType={validationMessageType}
									maxLength={200}
								/>
								:
								null
							}

						</ div>
						:
						""
					}

					<RadioButtonText
						label={"Is het project reeds besproken met de dienst stedenbouw/leefmilieu?"}
						name={"projectBesprokenMetGemeentedienstStedenbouw"}
						value={minimaleEisen.projectBesprokenMetGemeentedienstStedenbouw}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						validationMessage={errors ? errors.projectBesprokenMetGemeentedienstStedenbouw : ''}
						validationMessageType={validationMessageType}
						nameJa="standpuntVanGemeentedienstStedenbouw"
						valueJa={minimaleEisen.standpuntVanGemeentedienstStedenbouw}
						labelJa="Advies/Visie van de dienst stedenbouw/leefmilieu"
						errorJa={errors ? errors.standpuntVanGemeentedienstStedenbouw : ''}
						maxLengthJa={2000}
					/>
				</div> : ""}
		</Fieldset>
	);
};

StedenbouwkundigHaalbaar.propTypes = {
	minimaleEisen: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	color: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	fileTypes: PropTypes.object,
	mapDeleteFile: PropTypes.func.isRequired,
	mapDropFiles: PropTypes.func.isRequired,
	getFilesForDossierComponent: PropTypes.func.isRequired,
	hasFilesForDossierComponent: PropTypes.func.isRequired,
	dossierType: PropTypes.number.isRequired,
	stedenbouwkundigeBestemmingen: PropTypes.array.isRequired,
	fileSessionStarted: PropTypes.bool,
	standVanZakenMER: PropTypes.array.isRequired,
	validationMessageType: PropTypes.string
};

export default StedenbouwkundigHaalbaar;